<p>view-alerts-list works!</p>
